
import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoleClient, PermissionClient } from '@/api'
import { IPermissionData } from '@/api/types'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
@Component({
  name: 'RoleEditor'
})
export default class extends BaseEditor {
  private permissionList:IPermissionData[]
  private permissionClient = new PermissionClient()
  public constructor() {
    super()
    this.client = new RoleClient()
    this.data = { name: '', description: '', permission_list: [] }
    this.rules = {
      name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      description: [{ required: true, message: '描述不能为空', trigger: 'blur' }]
    }
    this.permissionList = []
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getPermissionList()
  }

  protected formatData(data:any):any {
    if (data.permission_list === null) {
      data.permission_list = []
    } else {
      data.permission_list = JSON.parse(data.permission_list)
    }
    return data
  }

  private async getPermissionList() {
    this.permissionList = await this.permissionClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          description: true
        },
        order: ['createdAt']
      }
    })
  }
  public async reset() {
    this.data = { name: '', description: '', permission_list: [] }
  }

  protected generateData():any {
    return _.merge({ permission_list: JSON.stringify(this.data.permission_list) }, _.pick(this.data, ['name', 'description']))
  }
}
